import React, { memo, useCallback } from 'react';

/**
 * Modal for saving / renaming a screener.
 */
const SaveScreenerModal = memo(({ screenerName, onNameChange, onSave, onCancel, saveLoading }) => {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter' && screenerName.trim()) onSave();
    },
    [screenerName, onSave],
  );

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-[90%] max-w-md overflow-hidden shadow-xl">
        {/* Input */}
        <div className="p-4">
          <input
            type="text"
            value={screenerName}
            onChange={(e) => onNameChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter a name for this screener"
            className="w-full px-4 py-2.5 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-slate-600 focus:border-transparent"
            autoFocus
          />
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-3 p-2 border-t border-slate-200 bg-slate-50">
          <button
            className="px-4 py-2.5 bg-white text-slate-700 border border-slate-200 rounded-md cursor-pointer text-sm hover:bg-slate-50 transition-colors duration-150"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="px-5 py-2.5 bg-[#474747] text-white border-none rounded-md cursor-pointer text-sm font-medium hover:bg-slate-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-colors duration-150"
            onClick={onSave}
            disabled={!screenerName.trim() || saveLoading}
          >
            {saveLoading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
});

SaveScreenerModal.displayName = 'SaveScreenerModal';

export default SaveScreenerModal;
